import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import './IndustriesBanner.css'
import RichTextContent, { CmsText } from '../../../RichTextContent/RichTextContent'
import { useIndustriesSection } from '../../../../context/IndustryPageContext'
import { resolveMediaUrl } from '../../../../utils/resolveMediaUrl'

const IndustriesBanner = () => {
  const { section, loading } = useIndustriesSection('industries-banner')

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url
    return url ? resolveMediaUrl(url) : ''
  }, [section])

  if (loading || !section?.fields) return null

  const fields = section.fields

  return (
    <section className="industries-banner">
      <div className="ib-bg">
        {bgSrc ? <img src={bgSrc} alt="" /> : null}
        <div className="ib-overlay"></div>
      </div>

      <div className="ib-content">
        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="ib-subtitle"
          />
        ) : null}

        {fields.title ? (
          <CmsText content={fields.title} as="h1" className="ib-title" />
        ) : null}

        {fields.description ? (
          <RichTextContent
            content={fields.description}
            className="ib-description"
          />
        ) : null}

        <div className="ib-actions">
          {fields.buttonOutlineLink ? (
            <Link
              to={fields.buttonOutlineLink}
              className="ib-btn-outline buttonclip"
            >
              <CmsText content={fields.buttonOutlineText} as="span" />
            </Link>
          ) : null}

          {fields.buttonPrimaryLink ? (
            <Link
              to={fields.buttonPrimaryLink}
              className="ib-btn-primary buttonclip"
            >
              <CmsText content={fields.buttonPrimaryText} as="span" />
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  )
}

export default IndustriesBanner
